import { createModalStore } from '@/shared/lib/modal';

export const useCreateTeamspaceModal = createModalStore();
